export default "__VITE_ASSET__DrpVytVP__"